export default __webpack_public_path__ + "static/media/service_on_3.ebea658f.jpg";